import React from 'react';
const SRC = 'https://static.wixstatic.com/media/5e9922_0a9111966d7648649336e1f1546c5ec9~mv2.gif';
export function BlankImage({ className = 'blank-image', width, height = 1, alt = '', }) {
    return (React.createElement("img", { className: className, src: SRC, width: width, height: height, style: { border: '0px' }, alt: alt }));
}
//# sourceMappingURL=blank-image.js.map